/**
 * PATH: apps/quote/src/components/builder/panels/context-panel/helpers.ts
 * PURPOSE: Shared helpers for ContextPanel (file icons, formatting)
 */

import { FileText, FileImage, FileSpreadsheet, File } from 'lucide-react'
import { createElement } from 'react'

export function getFileIcon(fileType: string, fileName: string) {
  const ext = fileName.split('.').pop()?.toLowerCase() || ''

  if (fileType.startsWith('image/')) {
    return createElement(FileImage, { className: 'w-4 h-4 text-purple-600' })
  }
  if (['xlsx', 'xls', 'csv'].includes(ext) || fileType.includes('spreadsheet')) {
    return createElement(FileSpreadsheet, { className: 'w-4 h-4 text-green-600' })
  }
  if (ext === 'pdf' || fileType === 'application/pdf') {
    return createElement(FileText, { className: 'w-4 h-4 text-red-600' })
  }
  return createElement(File, { className: 'w-4 h-4 text-blue-600' })
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`
}
